import { createContext, useState, useRef, useEffect } from 'react';
import styles from './Dropdown.module.css';

// ✅ Add this line to export the context
export const DropdownContext = createContext();

export const CustomDropdown = ({ children, position = 'bottom-left', className = '' }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef();

    const toggle = () => setIsOpen(!isOpen);
    const close = () => setIsOpen(false);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                close();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);


    

    return (
        <DropdownContext.Provider value={{ isOpen, toggle, close, position }}>
            <div className={`${styles.dropdown} ${className}`} ref={dropdownRef}>
                {children}
            </div>
        </DropdownContext.Provider>
    );
};
